import { render, staticRenderFns } from "./DisplayValueFieldReadonly.vue?vue&type=template&id=3a385cfc&scoped=true"
import script from "./DisplayValueFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./DisplayValueFieldReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a385cfc",
  null
  
)

export default component.exports